import styled from 'styled-components';
import theme from '../../../theme';

type PostitionProps = {
    top?: number;
};

export const RotationTreeWrapper = styled.div`
    height: calc(100vh - ${theme.constants.pageHeaderHeight} - 80px);
    overflow: auto;
`;

export const RotationTree = styled.ul`
    .dragging {
        opacity: 0.4;
    }
    .dragging-over {
        opacity: 0;
        pointer-events: none;
    }

    .departed-port-call,
    .departed-berth-call {
        color: ${theme.colors.text.lightGrey};
    }

    .berth-call-list {
        display: none;
    }

    .open-port-node .berth-call-list {
        display: block;
        outline: none;
    }

    .manual-node-marker {
        font-size: 0.5rem;
        font-weight: 600;
        width: 13px;
        background: ${theme.colors.background.manualNode};
        border-radius: 50%;
        text-align: center;
        color: ${theme.colors.background.white};
        height: 13px;
        padding: 0px 3px;
    }

    .port-node {
        font-weight: 700;
        font-size: 0.9rem;
        outline: none;
    }

    .berth-node {
        border-left: 5px solid ${({ theme }) => theme.colors.background.white};
        font-weight: 700;
        font-size: 0.9rem;
        margin-left: -5px;
    }

    .rotation-list-item {
        font-size: 0.9rem;
        border-bottom: 2px solid ${theme.colors.background.portCallBorder};

        > .rotation-tree-item:hover,
        > .rotation-tree-item.context-menu-open {
            background: ${theme.colors.background.hover.default};
        }

        .rotation-tree-item {
            cursor: pointer;
            position: relative;
            text-align: left;
            box-shadow: 0 5px 5px -3px ${theme.colors.background.boxShadow};
            display: flex;
            flex: 1;
            justify-content: space-between;
            grid-gap: 5px;
            padding: 8px 0 8px 8px;
            height: 40px;

            &.is-selected-port-call,
            &.is-selected-berth-call {
                background: ${theme.colors.background.selected};
                outline: none;
            }
        }

        .port-call-item {
            cursor: pointer;
            font-weight: 700;
            white-space: nowrap;
            text-overflow: ellipsis;
            align-items: center;
            border-left: 5px solid ${({ theme }) => theme.colors.background.portNode};

            .port-name {
                flex: 0 0 calc(100% - 100px);
                position: relative;
                @media only screen and (max-width: 1920px) {
                    font-size: 0.7rem;
                    .voyage-nr {
                        display: table-cell;
                        font-size: 0.6rem;
                    }
                    .sep {
                        display: none;
                    }
                }
            }

            .sep {
                margin: 0 5px;
            }
        }

        .berth-call-item {
            font-weight: 500;
            padding: 8px 0 8px 4px;
            height: 34px;

            .berth-name {
                flex: 0 0 calc(100% - 100px);
                padding-left: 10px;
                font-size: 0.7rem;
                display: flex;
                align-items: center;
                padding-top: 4px;
            }

            .status-icon {
                font-size: 0.75rem;
                transform: scale(0.9);
            }
        }

        .icon-wrapper {
            flex: 0 0 10px;
            display: flex;
            justify-content: flex-end;
            gap: 4px;
            align-items: center;
        }

        .status-approved {
            font-size: 1.1rem;
        }
    }

    .berth-call-list .rotation-tree-item:hover,
    .berth-call-list .rotation-tree-item.context-menu-open {
        background: ${theme.colors.background.hover.default};
    }
`;

export const HighlightCargoes = styled.button`
    padding: 1px 2px;
    text-align: center;
    cursor: pointer;
    border: 1px solid transparent;
    margin: 0;
    background: transparent;
`;

export const RotationMenu = styled.ul<PostitionProps>`
    position: absolute;
    background: ${({ theme }) => theme.colors.background.white};
    padding: 10px;
    top: ${(props) => props.top ?? 0} px;
    left: 20px;
    z-index: 5;
    min-width: 250px;
    box-shadow: ${({ theme }) => theme.colors.shadow.ddd} 0px 2px 6px 2px;

    .dd-item {
        margin: 5px 0 5px 0;
        font-size: 0.8rem;
        display: flex;
        border-bottom: 1px solid ${({ theme }) => theme.colors.border.eee};
    }

    .menu-item {
        font-size: 0.75rem;
        font-weight: 500;
        cursor: pointer;
    }

    button {
        display: flex;
        gap: 10px;
        border: 0;
        border-radius: 4px;
        background: ${({ theme }) => theme.colors.background.white};
        align-items: center;
    }
`;

export const EmptyRotationMessage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    color: #666;
    font-style: italic;
    padding: 20px;
    text-align: center;
    font-size: 0.9rem;
`;
